import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

type ToolTipProps = {
  title?: string;
  placement?: 'right-start' | 'right' | 'right-end'; // and 9 remaining possible values from MUI
};

const ToolTip: React.FC<ToolTipProps> = ({
  title,
  placement = 'right-start',
}) => {
  return (
    <Tooltip title={title} placement={placement} arrow>
      <IconButton
        size="small"
        sx={{
          color: '#94A3B8',
          p: '2px',
          '&:hover': { color: 'var(--primary-color)' },
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: '1rem' }} />
      </IconButton>
    </Tooltip>
  );
};

export default ToolTip;
